import { useEffect } from 'react';

import { params } from '@aline/routes';
import type { GridFilterItem } from '@mui/x-data-grid-premium';
import { useConsumePendingParam } from 'src/helpers';

import { getRepositoryFilterItem } from './repository-url-filter';

/**
 * Applies a one-shot `?filter=` link to the Documents grid.
 *
 * The Documents tab stays mounted, so a notification click that only changes the query does not
 * remount the page. `filter` lives in the tab's pending params until this applies it.
 * Acknowledging the arrival is what stops that same link from reapplying on every tab switch.
 */
export function useApplyRepositoryUrlFilter(applyFilter: (filterItem: GridFilterItem) => void) {
  const [filterArrival, acknowledgeFilterArrival] = useConsumePendingParam(
    params.repositoryFilter.key
  );

  useEffect(() => {
    if (!filterArrival) return;

    const filterItem = getRepositoryFilterItem(filterArrival.value);
    acknowledgeFilterArrival();
    if (!filterItem) return;

    applyFilter(filterItem);
  }, [acknowledgeFilterArrival, applyFilter, filterArrival]);
}
